import { useTranslation } from 'react-i18next';
import Button from '@components/atoms/ui-kit/button.tsx';

type Props = {
  error: 'load' | 'save' | 'conflict';
  busy: boolean;
  onReload: () => void;
};

export const LiveSectionError = ({ error, busy, onReload }: Props) => {
  const { t } = useTranslation();
  return (
    <div role="alert" className="text-sm flex items-center gap-2">
      <span className="flex-1">{t(`live-section-${error}-error`)}</span>
      <Button
        size="small"
        variant="outline"
        label={t('live-section-reload')}
        disabled={busy}
        onClick={onReload}
      />
    </div>
  );
};
